import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <SectionHeading
          eyebrow="Categories"
          title="按事件类型逛证据"
          description="不同的瓜有不同的看重点，先选类型，再看该类型下的素材结构。"
        />

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((category) => (
            <Link
              key={category.slug}
              to={`/events?category=${category.slug}`}
              className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-100 p-5 md:p-6 transition-colors hover:border-accent-300/60 cursor-pointer"
            >
              <span className="w-12 h-12 shrink-0 flex items-center justify-center rounded-md bg-accent-100 text-accent-300 text-xl">
                <i className={category.icon} />
              </span>
              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 group-hover:text-accent-300 transition-colors">
                    {category.name}
                  </h3>
                  <span className="text-xs text-foreground-500">{category.count} 起</span>
                </div>
                <p className="mt-2 text-sm leading-6 text-foreground-500">{category.desc}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}